__turbopack_context__.v({
  "balloon": "LocationPlacemark-module-scss-module__5lvQjW__balloon",
  "balloonArrow": "LocationPlacemark-module-scss-module__5lvQjW__balloonArrow",
  "balloonContent": "LocationPlacemark-module-scss-module__5lvQjW__balloonContent",
  "balloonContentBody": "LocationPlacemark-module-scss-module__5lvQjW__balloonContentBody",
  "hover": "LocationPlacemark-module-scss-module__5lvQjW__hover",
  "icon": "LocationPlacemark-module-scss-module__5lvQjW__icon",
  "iconBlack": "LocationPlacemark-module-scss-module__5lvQjW__iconBlack",
});
